import { API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

// Handle Login Response
function handleLoginResponse(response) {
    const body = response?.data;

    if (body?.status === 1 && body?.data) {
        const { token, refreshToken, user } = body.data;

        if (!token || !user) {
            throw new Error("Invalid login response");
        }

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("accessToken", token);

        if (refreshToken) {
            localStorage.setItem("refreshToken", refreshToken);
        }

        return user;
    }

    throw new Error(body?.message || "Invalid credentials");
}

class AuthService {

    // Admin Login
    static async adminLogin(item) {
        const response = await axiosInstance.post(
            API_PATHS.adminlogin,
            item
        );

        return handleLoginResponse(response);
    }

    // Officer / Commander Login
    static async userLogin(item) {
        const response = await axiosInstance.post(
            API_PATHS.userlogin,
            item
        );

        return handleLoginResponse(response);
    }

    // Get Admin Profile
    static async getProfile() {
        const response = await axiosInstance.get(
            API_PATHS.getadminprofile
        );

        return response.data;
    }

    // Get Dashboard Statistics
    static async getDashboard() {
        try {
            const response = await axiosInstance.get(
                API_PATHS.admindashboard
            );

            if (response.data?.status !== 1) {
                throw new Error(
                    response.data?.message || "Failed to fetch dashboard"
                );
            }

            return response.data.data;
        } catch (error) {
            console.error(
                "Dashboard API Error:",
                error.response?.data || error.message
            );

            throw error;
        }
    }

    // Clear Election Data
    static async clearElectionData() {
        try {
            const response = await axiosInstance.delete(
                API_PATHS.clearElectionData,
                {
                    data: {
                        confirmation: "CLEAR_ALL_ELECTION_DATA"
                    }
                }
            );

            if (response.data?.success !== true) {
                throw new Error(
                    response.data?.message || "Failed to clear election data"
                );
            }

            return response.data;
        } catch (error) {
            console.error(
                "Clear Election Data API Error:",
                error.response?.data || error.message
            );

            throw error;
        }
    }

    // Logout
    static logout() {
        this.clearSession();
        return true;
    }

    // Clear Session
    static clearSession() {
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
    }

    // Get Stored User
    static getUserDetails() {
        try {
            const user = localStorage.getItem("user");
            return user ? JSON.parse(user) : null;
        } catch (error) {
            console.error("Error parsing user details:", error);
            return null;
        }
    }

    // Check Login
    static isAuthenticated() {
        return !!localStorage.getItem("accessToken");
    }
}

export default AuthService;